import { CheckOutlined, ContentCopyOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/joy";
import { useState } from "react";
import { toast } from "sonner";

type CopyButtonProps = {
  value: string;
  label?: string;
  color?: string;
};

function CopyButton({ value, label = "Copy", color }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Couldn't copy to clipboard");
    }
  };

  return (
    <Tooltip title={copied ? "Copied" : label} placement="top" size="sm">
      <IconButton
        size="sm"
        variant="plain"
        color="neutral"
        aria-label={label}
        onClick={handleCopy}
        sx={{
          "--IconButton-size": "26px",
          "--Icon-fontSize": "15px",
          ...(color && { color, "--Icon-color": color, "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" } }),
        }}
      >
        {copied ? <CheckOutlined /> : <ContentCopyOutlined />}
      </IconButton>
    </Tooltip>
  );
}

export default CopyButton;
